import FaceRegisterList from './FaceRegisterList';

export default FaceRegisterList;
